import { render, staticRenderFns } from "./MFormRadio.vue?vue&type=template&id=05a21e4c&"
import script from "./MFormRadio.vue?vue&type=script&lang=js&"
export * from "./MFormRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a21e4c')) {
      api.createRecord('05a21e4c', component.options)
    } else {
      api.reload('05a21e4c', component.options)
    }
    module.hot.accept("./MFormRadio.vue?vue&type=template&id=05a21e4c&", function () {
      api.rerender('05a21e4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MFormRadio.vue"
export default component.exports